module.exports = __webpack_public_path__ + "img/bigscoots_cf.55cca78b.png";